"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabelaCabecalho = TabelaCabecalho;
var react_1 = __importDefault(require("react"));
var TabelaCabecalhoCelula_1 = require("../TabelaCabecalhoCelula/TabelaCabecalhoCelula");
var OrdenacaoDirecao_1 = require("../../../enums/OrdenacaoDirecao");
var styles = require('./TabelaCabecalho.module.scss');
function TabelaCabecalho(_a) {
    var coluna = _a.coluna;
    return (react_1.default.createElement("thead", { className: styles.headerContainer },
        react_1.default.createElement("tr", null, coluna.map(function (col) {
            var _a;
            return (react_1.default.createElement(TabelaCabecalhoCelula_1.TabelaCabecalhoCelula, { key: String(col.key), style: { width: col.width, textAlign: (_a = col.align) !== null && _a !== void 0 ? _a : 'center' }, ordenavel: col.ordenavel, onOrdenar: col.onOrdenar ? function () { return col.onOrdenar(col.key, col.ordenacaoDirecao === OrdenacaoDirecao_1.OrdenacaoDirecao.ASC ? OrdenacaoDirecao_1.OrdenacaoDirecao.DESC : OrdenacaoDirecao_1.OrdenacaoDirecao.ASC); } : undefined, direcaoAtualOrdenacao: col.ordenavel ? col.ordenacaoDirecao : undefined }, col.header));
        }))));
}
